// Build / environment flags. Mirrors the reference games'
// config/firebase.js + config/urls.js + native/appVersion.js, trimmed to what
// this local test build needs.

export const BUILD_ID: string =
  (import.meta as { env?: Record<string, string> }).env?.VITE_BUILD_ID ?? "dev";

export const DEV_PARAM = "dev";

export function isDevMode(href?: string): boolean {
  try {
    const loc = href ?? (typeof window !== "undefined" ? window.location.href : "");
    if (!loc) return false;
    return new URL(loc, "http://localhost").searchParams.has(DEV_PARAM);
  } catch {
    return false;
  }
}

// Firebase web configuration — PUBLIC values (security is enforced by Auth +
// Firestore rules, not by hiding config). Project new-2026-8eb33 is shared
// with the other Gamzone games (2026, Coin Exchanger): users/{uid}'s `points`
// wallet is deliberately common across them, while this game's own records
// live in their own field (see cloudPoints.ts's `othellosScores`) so no game
// overwrites another's data. This app's own "Othellos(web)" registration:
// appId 1:410965438908:web:90f16781de1ca84a047bb9.
export const firebaseConfig = {
  apiKey: "AIzaSyCHYrSsQ6lUQ1omME4NegmBiSzh5BBp-qU",
  authDomain: "new-2026-8eb33.firebaseapp.com",
  projectId: "new-2026-8eb33",
  storageBucket: "new-2026-8eb33.firebasestorage.app",
  messagingSenderId: "410965438908",
  appId: "1:410965438908:web:90f16781de1ca84a047bb9",
  measurementId: "G-Z45LRXPHMG",
};

/** True once the real config is present (apiKey + appId). */
export function isFirebaseConfigured(): boolean {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.appId);
}

export const IS_MOCK_PLATFORM = true;
